import { css } from 'styled-components';

import { getDimension } from './getDimension';
import type { Size, Theme } from 'styled/types';

interface WithPadding {
  /**
   * padding=0 turns this off entirely;
   * padding='sm' (etc) sizes the padding.
   * padding=undefined = some padding;
   */
  padding?: Size;
  bottomPadding?: Size;
  theme?: Theme;
}

export const bodyPaddingMixin = ({ padding, bottomPadding, theme }: WithPadding) =>
  padding !== 0 &&
  css`
    padding: ${getDimension(`size${padding || 0}`)({ theme })};
    padding-left: ${getDimension('size8')({ theme })};
    padding-right: ${getDimension('size8')({ theme })};

    ${bottomPadding &&
    css`
      padding-bottom: ${getDimension(`size${bottomPadding}`)({ theme })};
    `}

    ${theme?.breakpoints.down('md')} {
      padding-left: ${getDimension('size4')({ theme })};
      padding-right: ${getDimension('size4')({ theme })};
    }

    ${padding === 15 &&
    css`
      /* scales the padding from 92px on desktop to 32px on mobile */
      ${theme?.breakpoints.down('md')} {
        padding-top: ${getDimension('size8')};
        padding-bottom: ${getDimension('size8')};
      }
    `}
  `;
